module.exports = __webpack_public_path__ + "static/media/capacity_factor_availability.2f8bb625.svg";